import Loadable from 'react-loadable';

export const ProfileLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "profile" */ './index'),
  loading: () => null,
});
